
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { getNoticeList } from '../service/getdata'
export default{
components:{
XHeader,
Toast
},
data(){
return{
msg: "",
show: false,
list: [], //帮助中心列表
}
},
computed:{
...mapState(['token'])
},
created(){
this.SETTOKEN()
this.getData()
},
methods:{
...mapMutations(['SETUSERDETAIL','SETUSER','SETTOKEN',"CLEAN_ALL"]),
getData(){
var that = this
this.$Loading()
getNoticeList({token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.list = res.data
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
},
sendMsg(content) {
this.msg = content;
this.show = true;
},


},
watch:{

}
}



// WEBPACK FOOTER //
// ./src/pages/noticeList.vue